import React,{useEffect, useState,useRef} from 'react';
import SearchInterface from '../../shared/components/UIElements/SearchInterface';
import Results from '../../shared/components/UIElements/Results';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';

import './Classes.css';

const Classes = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filteredClasses, setFilteredClasses]= useState();
  const [allClasses, setAllClasses]= useState();
  const [spOperation, setSpOperation]= useState("intersects");
  const [textValue, setTextValue]= useState();
  const textValueRef= useRef('');
  const initialBounds=[[-180,-90],[180,90]];
  const [mapBounds, setMapBounds]= useState([[-180,-90],[180,90]]);
  const mapBoundsRef=useRef(mapBounds);
  const spOperationRef=useRef(spOperation);
  const mapRef=useRef(null);
  const resultType='classes';
  let map;

  useEffect(()=>{
    window.scrollTo(0, 0);
    const sendRequest = async() =>{
      setIsLoading(true);
      const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/classes/');
      const responseData= await response.json();
      setAllClasses(responseData);
      setFilteredClasses(responseData);
      setIsLoading(false);
    };
    sendRequest();
  },[]);

  useEffect(()=>{
    map=mapRef.current.leafletElement;
  },[initialBounds] );


  const textChangeHandler = val => {
    setIsLoading(true);
    setTextValue(val);
    textValueRef.current=val;
    mapBoundsRef.current=map.getBounds();
    filterClasses(textValueRef.current,mapBoundsRef.current,spOperationRef.current);
    setIsLoading(false);  
   };

   const MapChangedHandler =  () => {
    setIsLoading(true);
    if (map!=null){
      const searchBounds=map.getBounds();
      setMapBounds(searchBounds);
      mapBoundsRef.current=searchBounds;
      filterClasses(textValueRef.current,mapBoundsRef.current,spOperationRef.current);
    }
    setIsLoading(false);
}

const spOperationChangeHandler =(val) =>{
  spOperationRef.current=val;
  setSpOperation(val);
  MapChangedHandler();
}

const filterClasses = (te,ma,sp) =>{
  if (te===''){
    setFilteredClasses(allClasses.filter(cs=> ma[sp](JSON.parse(cs.bbox))));
  }else{
    setFilteredClasses(allClasses.filter(cs=>(cs.title.toLowerCase().indexOf(te.toLowerCase())>-1  || cs.description.toLowerCase().indexOf(te.toLowerCase())>-1  || cs.dataset.toLowerCase().indexOf(te.toLowerCase())>-1) && ma[sp](JSON.parse(cs.bbox))));   
  }
 }
 
 const clearFilters = () =>{
  setIsLoading(true);
  textValueRef.current='';
  setTextValue('');
  spOperationRef.current='intersects';
  setMapBounds(initialBounds);
  setSpOperation('intersects');
  map.fitBounds(initialBounds);
  setFilteredClasses(allClasses);
  setIsLoading(false); 
 }
 
  return (<div className="mainDiv">
    {isLoading &&(<div className="center"><LoadingSpinner asOverlay/></div>)} 
    <SearchInterface 
               bounds={initialBounds}
               forwardedRef={mapRef}
               textValue={textValueRef.current}
               onTextChange={(e)=>textChangeHandler(e.target.value)} 
               onMapChange={MapChangedHandler}
               spOperation={spOperationRef.current}
               onSpOperationChange={(v)=>spOperationChangeHandler(v.target.value)}
               onClear={clearFilters}/>
    
    
    {!isLoading && filteredClasses && <Results type={resultType} items={filteredClasses}/>}
     
</div>);
  };
  
  export default Classes;